import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { onlyUnique } from '../../functions/meta.functions';
import { LastRechtGruppeEntryMeta } from '../../../core/gb-api';

@Pipe({
  name: 'orderByLastRechtGruppe'
})
export class OrderByLastRechtGruppePipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array, ascending = true): LastRechtGruppeEntryMeta[] {
    if (ascending) {
      return Array.from(array)
        .filter(onlyUnique)
        .sort((item1: any, item2: any) => {
          return this.orderByComparator(item1, item2);
        });
    } else {
      return Array.from(array)
        .filter(onlyUnique)
        .sort((item1: any, item2: any) => {
          return this.orderByComparator(item2, item1);
        });
    }
  }

  private orderByComparator(a: LastRechtGruppeEntryMeta, b: LastRechtGruppeEntryMeta): number {
    return this.comperatorService.lastRechtComparator(a, b);
  }
}
